/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasGridCellBase } from "./CanvasGridCellBase";
import { CanvasTemplateCellContainer } from "./CanvasTemplateCellContainer";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasTemplateHeaderCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasTemplateHeaderCell, _super);
    function CanvasTemplateHeaderCell(a) {
        var _this = _super.call(this, a) || this;
        _this.c3 = null;
        _this.c3 = new CanvasTemplateCellContainer(a);
        return _this;
    }
    Object.defineProperty(CanvasTemplateHeaderCell.prototype, "c4", {
        get: function () {
            return this.c3;
        },
        enumerable: true,
        configurable: true
    });
    CanvasTemplateHeaderCell.prototype.get_z = function () {
        return true;
    };
    CanvasTemplateHeaderCell.prototype.c5 = function () {
        this.b1();
    };
    CanvasTemplateHeaderCell.$t = markType(CanvasTemplateHeaderCell, 'CanvasTemplateHeaderCell', CanvasGridCellBase.$);
    return CanvasTemplateHeaderCell;
}(CanvasGridCellBase));
export { CanvasTemplateHeaderCell };
//# sourceMappingURL=CanvasTemplateHeaderCell.js.map
